/**
 * サブヘッダー
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { SupportComponent } from '@lib/components/support-class';
import { isPC, isSP, isTB } from 'src/lib/helpers';

/**
 * サブヘッダー
 */
@Component({
  selector: 'asw-reservation-search-sub-header',
  templateUrl: './booking-search-sub-header.component.html',
  styleUrls: ['./booking-search-sub-header.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingSearchSubHeaderComponent extends SupportComponent {
  /** 画面タイトル */
  public displayTitle: string = 'label.searchReservation';

  /** ブレッドクラム表示判定 */
  public isBreadcrumbDisplay: boolean = false;

  /** デバイス判定のための変数 */
  public isPC = false; // PCかどうか
  public isTB = false; // タブレットかどうか
  public isSP = false; // スマホかどうか

  /** ブレッドクラムのステップ数保持のための変数 */
  public stepNum: number = 5;
  public currentStepNum: number = 5;

  constructor(private _common: CommonLibService, private changeDetectorRef: ChangeDetectorRef) {
    super(_common);
  }

  reload(): void {}
  init(): void {
    // 該当する端末にtrueを設定する
    this.isPC = isPC();
    this.isTB = isTB();
    this.isSP = isSP();
  }
  destroy(): void {}
}
